import { useEffect } from "react";
import type { AppScreen, DashboardView } from "./navigation.js";
import { pathForRoute, routeForPath, type Route } from "./routing.js";

/**
 * Keeps the address bar and the open screen in step (D142).
 *
 * The URL follows the screen, and `popstate` pushes it back, so refresh, the
 * back button, and a shared link all resolve to the same place.
 */
export const useRouteSync = ({
  screen,
  dashboardView,
  matterId,
  threadId,
  onPopState,
}: {
  readonly screen: AppScreen;
  readonly dashboardView: DashboardView;
  readonly matterId: string | null;
  readonly threadId: string | null;
  readonly onPopState: (route: Route) => void;
}): void => {
  useEffect(() => {
    const next = pathForRoute({ screen, dashboardView, matterId, threadId });
    if (next !== globalThis.location.pathname) {
      globalThis.history.pushState(null, "", next);
    }
  }, [screen, dashboardView, matterId, threadId]);

  useEffect(() => {
    const handle = (): void => {
      onPopState(routeForPath(globalThis.location.pathname));
    };
    globalThis.addEventListener("popstate", handle);
    return () => {
      globalThis.removeEventListener("popstate", handle);
    };
  }, [onPopState]);
};
